import $ from 'jquery'
import { initSlides } from '../abstracts/utils'

export default () => {
  $(() => {
    if (!$('body').hasClass('single') || !$('body').hasClass('single-post')) return

    let $randomPosts = $('.random-posts')
    if ($randomPosts.length) {
      if ($(window).width() < 992) {
        initSlides($randomPosts.find('.slideshow:not(.slick-initialized.slick-slider)'))
      }
      $(window).resize(() => {
        if ($(window).width() < 992) {
          initSlides($randomPosts.find('.slideshow:not(.slick-initialized.slick-slider)'))
        } else {
          $randomPosts.find('.slideshow.slick-initialized.slick-slider').slick('unslick')
        }
      })
    }

  })
}
